export interface WeakRefInstance<T extends object> {
    deref(): T | undefined;
}

type WeakRefConstructor = {
    new <T extends object>(target: T): WeakRefInstance<T>;
};

export const NativeWeakRef: WeakRefConstructor = (globalThis as any).WeakRef;
